// src/App.js

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import LandingPage from "./pages/LandingPage"; // New public landing page component
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import SurveysPage from "./pages/SurveysPage";
import SurveyDetails from "./pages/SurveyDetails";
import Dashboard from "./pages/Dashboard";
import SharedSurveyPage from "./pages/SharedSurveyPage";
import GodAdminDashboard from "./pages/GodAdminDashboard";
import OrgAdminDashboard from "./pages/AgencyDashboard";

const App = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/login" element={<LoginPage />} />

      {/* Protected Routes */}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/surveys"
        element={
          <PrivateRoute>
            <SurveysPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/surveys/:id/details"
        element={
          <PrivateRoute>
            <SurveyDetails />
          </PrivateRoute>
        }
      />

      {/* God Admin Route (requires "godAdmin" role) */}
      <Route
        path="/god-admin"
        element={
          <PrivateRoute requiredRole="godAdmin">
            <GodAdminDashboard />
          </PrivateRoute>
        }
      />

      {/* Org Admin (Agency) Route (requires "orgAdmin" role) */}
      <Route
        path="/org-admin"
        element={
          <PrivateRoute requiredRole="orgAdmin">
            <OrgAdminDashboard />
          </PrivateRoute>
        }
      />

      {/* Shared Survey (Public) */}
      <Route path="/shared/:token" element={<SharedSurveyPage />} />

      {/* Redirect unknown routes to the landing page */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
